import { getToken, getMessaging, onMessage } from "firebase/messaging";
import { app } from "./firebase";

const passNotificationToApp = (data = {}) => {
  localStorage.setItem('has_notification', true);
  localStorage.setItem('last_encoded_notification', btoa(JSON.stringify(data)));
}

const web = {
  requestPermissionAndGetToken(){
    if (!("Notification" in window)) return Promise.resolve(false);
    console.log("requesting permission");

    return new Promise((resolve, reject) => {
      Notification.requestPermission()
        .then((permission) => {
          if (permission !== 'granted') return resolve(false);

          const messaging = getMessaging(app);
          getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY })
            .then((currentToken) => {
              if (!currentToken) {
                reject("No registration token available. Request permission to generate one.");
                return;
              }
              resolve(currentToken);
            });
        });
    })
  },
  registerFcmForForeground(){
    console.log("registering firebase messaging for foreground : web");

    this.registerNotificationApiOnClickListener();
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {
      console.log("Notification received in foreground");
      const notificationTitle = payload.data?.title || 'New Notification from Rasiklal Sons'
      const notificationOptions = {
        body: payload.data?.body || '',
        icon: '/rasiklalLogo.jpg',
        image: payload.data?.image,
        data: payload.data
      };
      navigator.serviceWorker.ready.then(function(registration) {
        registration.showNotification(notificationTitle, notificationOptions);
      });
    });
  },
  // private
  registerNotificationApiOnClickListener(){
    navigator.serviceWorker.addEventListener('notificationclick', function (event){
      event.notification.close();
      passNotificationToApp(event.notification.data);
      if (typeof window !== 'undefined'){
        if (window.location.pathname === '/switcher') return window.location.reload();
        window.location.href = '/#/switcher';
      } 
    } );
  }
};

const cordova = {
  requestPermissionAndGetToken: async function() {
    if (!window.cordova) return Promise.resolve(false);
    console.log("requesting permission");

    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('notifications_permission_asked')){
        try {
          window.cordova.plugins.notification.local.requestPermission(function (granted) {
            localStorage.setItem('notifications_permission_asked',true);
            if (granted) return FirebasePlugin.getToken((fcmToken) => resolve(fcmToken), (err) => reject(err))
          }); 
        } catch (error) {
          return reject(error);
        }
        return;
      } 

      window.cordova.plugins.notification.local.hasPermission(function (granted) {  if (granted) return FirebasePlugin.getToken((fcmToken) => resolve(fcmToken), (err) => reject(err)); });
    })
  },
  registerFcm: function() {
    if (!window.cordova) return;
    console.log("registering firebase messaging: cordova");

    const me = this;
    FirebasePlugin.onMessageReceived(
      function (message) {
          console.log("Notification received : ", {message});
          if (message.messageType !== "notification") return;

          // tapped background notification
          if (message.tap === 'background') return passNotificationToApp(message);
          
          // background notification
          if (message.show_notification !== "false") return;
          
          me.registerLocalNotificationOnClickListener();
          return me.showLocalNotification(message, true);
      },
      (error) => console.error(error)
    );
  },
  // private
  registerLocalNotificationOnClickListener() {
    if (window.registered_local_notification_click_listener) return;

    try {
      window.cordova.plugins.notification.local.on("click", function (notification) {
        console.log("Notification clicked", {notification});
        
        passNotificationToApp(notification.data);
        return window.location.href = `/#/switcher`;
      });
      window.registered_local_notification_click_listener = true;
    } catch (error) {
      console.log(error);
      passNotificationToApp();
    }
  },
  showLocalNotification(payload, isForeground) {
    window.cordova.plugins.notification.local.schedule({
        id: Date.now(),
        title: payload.title || 'New Notification from Rasiklal Sons',
        text: payload.body || '',
        androidLargeIcon: '/rasiklalLogo.jpg',
        image: payload.image,
        iOSForeground: isForeground,
        data: payload,
        trigger: { at: new Date(new Date().getTime() + 500) }
    });
  },
}

export const platforms = { web, cordova };